import Vue from "vue";
import {api as configs} from "@/app/config";
import {getData} from "@/app/plugins/utils";

export const getProgressionTPV = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/progression_tpv'+payload).then(getData)
}
export const getSellFails = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/sell_fails'+payload).then(getData)
}
export const getSellType = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/sell_per_type_payment'+payload).then(getData)
}

export const getProgressionEC = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/progression_ec'+payload).then(getData)
}

export const getTicketMedio = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/average_ticket'+payload).then(getData)
}
export const getQuantidadeTransacao = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/quantity_transaction'+payload).then(getData)
}

export const getCHURN = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/churn'+payload).then(getData)
}
export const getProgressaoMarkups = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/progression_markup'+payload).then(getData)
}
export const getPercentualMarkups = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/percentual_markup'+payload).then(getData)
}
export const getSellsCurrentDay = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/sells_current_day'+payload).then(getData)
}
export const getSellsCurrentMonth = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/sells_current_month'+payload).then(getData)
}
export const getAccreditationPending = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/accreditation_pending'+payload).then(getData)
}
export const getAccreditationSucceeded = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/accreditation_succeeded'+payload).then(getData)
}
export const getClientsActive = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/clients_active'+payload).then(getData)
}
export const getClientsEnabledTransactions = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/clients_enabled_transaction'+payload).then(getData)
}
export const getAdjustsCurrentMonth = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/adjusts_current_month'+payload).then(getData)
}
export const getAdjustsPendingCurrentMonth = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/adjusts_pending_current_month'+payload).then(getData)
}
export const getChargeBackCurrentMonth = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'statistics/chargeback_current_month'+payload).then(getData)
}

// exchange account
export const switchAccount = (account) =>
  Vue.http.get(configs.baseUrl+'accounts/'+account+'/switch').then(getData)

export const getAcceptTerms = (payload = '') => {
  return Vue.http.get(configs.baseUrl+'user/getAcceptTerms').then(getData)
}
export const postAcceptTerms = (payload = '') => {
  return Vue.http.post(configs.baseUrl+'user/setAcceptTerms/'+payload).then(getData)
}